import { useI18n } from 'vue-i18n'
import useBlProviders from '@/composables/providers/useBlProvider'
import FuelStationsDt from '@/services/dataTransferModules/fuelStationsDt'

const fuelStationsDt = new FuelStationsDt()

export default function useFuelStations() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fuelStations,
		getEntities: getFuelStations,

		entity: fuelStation,
		getEntity: getFuelStation,

		entityPreview: fuelStationPreview,
		getEntityPreview: getFuelStationPreview,

		entityPopup: fuelStationPopup,
		getEntityPopup: getFuelStationPopup,

		createEntity: createFuelStation,
		updateEntity: putFuelStation,
		patchEntity: patchFuelStation,
		deleteEntity: deleteFuelStation,
	} = useBlProviders(fuelStationsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Loading error'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Loading error'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error creating fuel station'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error while updating fuel station'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Error while deleting fuel station'),
	})

	const defaults = {
		creatingFuelStation: {
			name: '',
			guns: [],
			default_fuel_type: null,
			moving_device: null,
			storage: null,
			location: '',
			source_type: '',
			station_type: '',
			state: {},
		},
		fieldsToPatch: [
			'name',
			'default_fuel_type',
			'moving_device',
			'storage',
			'source_type',
			'station_type',
			// "state",
		],
	}

	return {
		flags,
		defaults,
		fuelStations,
		fuelStation,
		fuelStationPreview,
		fuelStationPopup,
		getFuelStations,
		getFuelStation,
		getFuelStationPreview,
		getFuelStationPopup,
		createFuelStation,
		putFuelStation,
		patchFuelStation,
		deleteFuelStation,
	}
}